import { Height } from "@mui/icons-material";
import React, { useState } from "react";
import TagComp from "../../NewComponent/Tag/TagComp";
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action/index';
import { CURRENT_ROLE } from "../../API/url";
export default function Tags({ data, edit, setEdit, clarified, isShowAnswerButton }) {
    const dispatch = useDispatch();
    const {getkeyTagPayload} = bindActionCreators(Actions, dispatch)
  const containerStyle = {
    border: "1px solid #F6F7F8",
    marginBlock: "10px",
    borderRadius: "6px",
    background: "#F6F7F8",
    padding: "12px",
    minHeight: "48px",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  };
  const textStyles = {
    fontSize: "14px",
    color: "#2A364A",
    lineHeight: "22px",
    fontWeight: "300",
    display: "flex",
  };

  const requestClarificationStyles = {
    borderRadius: "6px",
    height: "24px",
    padding: "1px 8px",
    color: "#fff",
    textAlign: "center",
    background:
      "linear-gradient(90.39deg, rgb(255, 160, 80) 0%, #fd7400 50%, rgb(197, 55, 0) 100%)",
    fontSize: "13px",
    marginLeft: "5px",
    fontWeight: "300",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  };

  const requestedUpdateStyles = {
    borderRadius: "6px",
    height: "24px",
    padding: "1px 8px",
    color: "#fff",
    textAlign: "center",
    background:
      "linear-gradient(90.39deg, rgb(108, 148, 186) 0%, rgb(63, 102, 155) 40%, rgb(58, 99, 144) 100%)",
    fontSize: "13px",
    marginLeft: "5px",
    fontWeight: "300",
    display: "flex",
    alignItems: "center",
  };

  const requestClarifiedStyles = {
    borderRadius: "6px",
    height: "24px",
    padding: "1px 8px",
    color: "#fff",
    textAlign: "center",
    background:
      "linear-gradient(90.39deg, #28a745 0%, #218838 50%, #19692c 100%)",
    fontSize: "13px",
    marginLeft: "5px",
    fontWeight: "300",
    display: "flex",
    alignItems: "center",
  };
  const [tags, setTags] = useState(
    Array.isArray(data.tags) && data.tags.length > 0
      ? data.tags.filter((tag) => tag.clickable)
      : []
  );
  const onClickTag = (dt)=>{
    let filteredData = tags.filter((tag=>{
        return tag.term===dt;
    }));
    getkeyTagPayload({tag:filteredData[0].term,key:'expert'});
}
  return (
    <>
      <div style={containerStyle}>
        {
          <div style={textStyles}>
            Domain&nbsp;
            <TagComp title={data.domain} />
            &nbsp;&nbsp;
          </div>
        }
        {tags.length !== 0 && (
          <div style={textStyles}>
            Tags&nbsp;
            {tags.map((tag) => {
              if (tag.clickable) {
                return <TagComp key={tag.term} title={tag.term} onClickFunc={onClickTag} />;
              }
            })}
            &nbsp;&nbsp;
          </div>
        )}
        {/* {data.clarificationStatus && (
        <div style={textStyles}>{"  "}Status:{"  "}
        <div onClick={()=>setEdit(!edit)} style={requestClarificationStyles}>Expert Requested For Clarification</div></div>)} */}
        {(data.clarificationStatus || data.userInitiatedCuration) && (
          <div style={textStyles} className="tags-layer">
            {/* Status:{" "} */}
            {data.userInitiatedCuration && isShowAnswerButton && (
              <>
              Status&nbsp;
              <div style={requestedUpdateStyles}>Requested Update</div>
              </>
            )}
            {data.clarificationStatus  && CURRENT_ROLE === 'Seeker' && (
              <>
              Status&nbsp;
              <div
                style={requestClarificationStyles}
                onClick={() => setEdit(!edit)}
              >
                Expert Requested For Clarification
              </div>
              </>
            )}
            {clarified && (
              <div style={requestClarifiedStyles}>Request Clarified</div>
            )}
          </div>
        )}
      </div>
    </>
  );
}
